import { Link } from "react-router-dom";
import { useSEO } from "@/lib/seo";

export default function NotFound() {
  useSEO({ title: "Page not found, Bellhouse Law" });
  return (
    <div
      data-testid="not-found-page"
      className="container-narrow flex min-h-[80vh] flex-col items-center justify-center text-center"
    >
      <span className="eyebrow">404</span>
      <h1 className="mt-4 font-serif text-5xl text-ink md:text-6xl">
        This page slipped away.
      </h1>
      <p className="mt-5 max-w-md text-base text-ink-soft">
        The page you were looking for can&apos;t be found. Let&apos;s get you back to
        something useful.
      </p>
      <Link to="/" data-testid="not-found-home" className="btn-primary mt-10">
        Return Home
      </Link>
    </div>
  );
}
